"use client";

import { useState, type ReactNode } from "react";
import dynamic from "next/dynamic";
import type { ArticlePosition } from "@/content/blog/types";
import type { Tutorial } from "@/lib/tutorial/types";

const Experience = dynamic(() => import("./ArticleExperience"), {
  ssr: false,
  loading: () => <p className="article-loading" role="status">Preparing your board…</p>,
});

export function ArticleInteraction({ positions, tutorial, children }: { positions: ArticlePosition[]; tutorial?: Tutorial; children: ReactNode }) {
  const [active, setActive] = useState(false);
  return <div className="article-interaction">
    {active ? <>
      <Experience positions={positions} tutorial={tutorial} />
      <button className="article-text-button" onClick={() => setActive(false)}>Close interactive board</button>
    </> : <div className="article-interaction-cover">
      <div>{children}</div>
      <div className="article-interaction-copy">
        <p className="eyebrow">{tutorial ? "See the idea in motion" : "Your move"}</p>
        <h3>{tutorial?.title ?? "Put the idea to the test"}</h3>
        <p>{tutorial?.summary ?? positions[0].challenge?.prompt}</p>
        <button className="button-primary" onClick={() => setActive(true)}>{tutorial ? "Watch the 3D lesson" : "Try this position"}<span aria-hidden="true">↗</span></button>
        <span className="article-interaction-note">{tutorial ? "Pause, step through, or switch to 2D." : "Explore in 3D, or switch to 2D."}</span>
      </div>
    </div>}
  </div>;
}
